import React, { ChangeEvent, Component, type JSX } from 'react';
import { Subjects } from './FrontSearchSubjects';
import * as params from '../../util/getQueryParams';
import 'devbridge-autocomplete';
import { EXT_SUBJECTS } from './subject.data';

let queryParams = params.getQueryParams(document.location.search);

interface ComponentProps {
  initialLevel: string|null;
  initialSubject: string|null;
}

interface ComponentState {
  level: string;
}

/**
 * This component replaces the existing twig RichDropdown with a
 * react component so we can show the fields relevant for the
 * chosen level
 */
export class FrontSearchExt extends Component<ComponentProps, ComponentState> {

  // set the initial state according to the query params in the users addressbar
  public state: ComponentState = {
    level: queryParams.level as string || 'ALL',
  };

  public componentDidMount(): void {
    if (this.props.initialLevel) {
      this.setState({ level: this.props.initialLevel });
    }
  }

  /**
   * Set the selected level.
   */
  public changeLevel(e: ChangeEvent<HTMLSelectElement>): void {
    let value: string = e.target.value as string;

    // Hide the lavel validation error.
    $('.js-search-level-validation').hide();

    this.setState({ level: value });
  }

  /**
   * Render the level and (richdropdown)subjects field
   */
  public render(): JSX.Element {
    let { level } = this.state;

    const selectedLevel = level.toUpperCase();
    const subjectList = EXT_SUBJECTS[selectedLevel];
    const selectedSubject: string[] = this.props.initialSubject
      ? [this.props.initialSubject.toLowerCase()]
      : (queryParams.subject as string[] || []).map(s => s.toLowerCase());

    return (
      <>
        <select name="level"
          className="front-search__form-field front-search__form-field--required front-search__form-field--first form-control"
          onChange={(e: ChangeEvent<HTMLSelectElement>): void => this.changeLevel(e)}
          value={selectedLevel}>
          <option value="ALL" disabled={true}>Kies niveau...</option>
          <option value="VMBO TL">VMBO TL</option>
          <option value="HAVO">HAVO</option>
          <option value="VWO">VWO</option>
        </select>
        <Subjects subjects={subjectList} selected={selectedSubject} />
      </>
    );
  }
}
